let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("52kTj")).then(() => parcelRequire('4eC1j'));